import React from 'react'

const Sanskritikonayayatra = () => {
  return (
    <div>
      <div>
        <h3>शब्दभण्डार</h3>
        <h5>१. उस्तै अर्थ आउने शब्दहरुको जोडा मिलाउनुहोस् ।</h5>
        <p>प्रतिष्ठा : इज्जत</p>
        <p>एकाकार : एकै किसिमको</p>
        <p>उत्पीडन : पीडा दिइएको</p>
        <p>विद्रोह : ठूलो विरोध</p>
        <p>कार्यान्वयन : विधिपूर्वक व्यवहारमा ल्याउने काम</p>
        <p>प्रवाहशील : निरन्तर बगिरहने</p>
      </div>
      <hr/>
      <div>
        <h5>२. दिइएका अर्थ मिल्ने पदावलीहरु पाठबाट खोजेर लेख्नुहोस् ।</h5>
        <p>(क) जीवनलाई पवित्र पार्ने काम : जीवनबोध</p>
        <p>(ख) समुद्रको जहाजमा बसेर यात्रा गर्ने : नाविक यात्रा</p>
        <p>(ग) एउटै मात्र संस्कृति : एकल संस्कृति</p>
        <p>(घ) यात्रालाई प्रत्येक्ष हेर्ने दर्शक : यात्राको साक्षी</p>
        <p>(ङ) सांस्कृतिक हिसाबले प्राप्त गर्ने न्याय : साँस्कृतिक न्याय</p>
        <p>(च) विचलित नहुने यात्रा : अविचलित यात्रा</p>
        <p>(छ) सबैको हग लाग्ने सन्तति : साझा सन्तति</p>
      </div>
      <hr/>
      <div>
        <h5>३. शब्दकोश हेरेर दिइएका शब्दहरुको अर्थ लेख्नुहोस् ।</h5>
        <p>स्मृति : स्मरण , सम्झना</p>
        <p>जिज्ञासा : कुनै कुरा जान्ने इच्छा</p>
        <p>जीववैज्ञानिक : जीव विज्ञानसम्बन्धी अध्ययन गर्ने व्यक्ति</p>
        <p>प्रगति : उन्नति , विकास</p>
        <p>सामेल : भेला, तोकिएको ठाउँमा उपस्थित हुने काम</p>
        <p>दमन : चिचोमिचो, दबदबाउ</p>
        <p>मनुष्यत्व : मनुष्य हुनुको भाव, मानवता</p>
        <p>दमित : दमन गरिएको, दविएको</p>
        <p>बाहिष्कार : खारेजी, निष्कासन</p>
      </div>
      <hr/>
      <div>
        <h5>४. दिइएका शब्दलाई वाक्यमा प्रयोग गर्नुहोस् ।</h5>
        <strong>उदात्त</strong>
        <p>आमाबाबुको माया संसारकै सबैभन्दा उदात्त भावना हो।</p>
        <strong>अनुभूति</strong>
        <p>विज्ञान विषय पढ्दा मलाई गहिरो अनुभूति भएको छ कि यो मेरो लागि उपयुक्त छ।</p>
        <strong>सुनिश्चितता</strong>
        <p>सरकारले नयाँ शैक्षिक सत्रमा पाठ्यक्रमको सुनिश्चितता अझै स्पष्ट पारेको छैन।</p>
        <strong>दमक</strong>
        <p>गरिबीले पिल्सिएको समाजमा अझै पनि धनीहरूले गरिबमाथि दमक गरिरहेका छन्।</p>
        <strong>पङ्खफुका</strong>
        <p>अहिलेको कठिन समयमा फजुल पङ्खफुका गर्नु उपयुक्त हुँदैन।</p>
        <strong>निर्मित</strong>
        <p>अयोध्यामा राम मन्दिरमा भगवान रामको मूर्ति भव्य रूपमा निर्मित गरिएको छ।</p>
        <strong>न्यायपूर्ण</strong>
        <p>सबै नागरिकलाई समान व्यवहार गर्ने नीति नै न्यायपूर्ण समाजको आधार हो।</p>
        <strong>अविचलित</strong>
        <p>असफलता आइपरे पनि हामीले आफ्नो लक्ष्यप्रति अविचलित रहनु पर्छ।</p>
      </div>
      <hr/>
      <div>
        <h5>५. दिइएका विषयक्षेत्रका शब्दहरु खोजेर लेख्नुहोस् ।</h5>
        <strong>(क) नेपाली चाडपर्वहरु</strong>
        <p>तिज, दसैं, तिहार, पुर्णिामा, ल्होसार, माघी </p>
        <strong>(ख) नेपाली नृत्यहरु</strong>
        <p>साकेला, लाखे, देउडा, सोरठी </p>
        <strong>(ग) नेपालका भाषाहरु</strong>
        <p>नेपाली, मैथिली, भोजपुरी, थारु, कुमाले, माझी, नेवारी </p>
        <strong>(घ) नेपालीका पोसाक</strong>
        <p>दौरा, सुरुवाल, ढाकाटोपी, चोली, पटुका, धोती </p>
        <strong>(ङ) नेपाली खानाका स्थानीय परिकार</strong>
        <p>दाल, भात, रोटी, तरकारी, अचार, खीर</p>
      </div>
      <hr/>
      <div>
        <h3>बोध र अभिव्यक्ति</h3>
        <h5>२. दिइएका प्रश्नहरुको उत्तर दिनुहोस् ।</h5>
        <h5>(क) माथिको पाठ कति अनुच्छेदमा संरचित छ ?</h5>
        <p>= माथिको पाठ आठवटा अनुच्छेदमा संरचित छ।</p>
        <h5>(ख) पाठको दोस्रो अनुच्छेदमा कुन विषयलाई मुख्य भाव वा विचार बनाइएको छ ?</h5>
        <p>= पाठको दोस्रो अनुच्छेदमा जीवनयात्राको क्रममा बहुजातीयतामा फुलेको नेपाली कला र संस्कृतिको विशेषता मुख्य विचार बनाइएको छ।</p>
        <h5>(ग) पाठको छैटौं अनुच्छेदमा कस्ता विषय वस्तुलाई प्रस्तुत गरिएको छ ?</h5>
        <p>= पाठको छैटौं अनुच्छेदमा सांस्कृतिका नाममा देखिने विकृति र विसङ्गतिहरूको अन्त्य हुनुपर्ने आवश्यकता प्रस्तुत गरिएको छ।</p>
        <h5>(घ) निबन्धको पाँचौं अनुच्छेदमा कतिवटा वाक्यहरु छन् ?</h5>
        <p>= निबन्धको पाँचौं अनुच्छेदमा २२ वटा वाक्यहरू छन्।</p> 
      </div>
      <hr/>
      <div>
        <h5>४. पाठको आधारमा उपयुक्त विकल्प छानी खाली ठाउँ भर्नुहोस् ।</h5>
        <p>(क) जब म यो नै संस्कृति हो भनेर बुझ्न थालेँ, त्यति बेलासम्म र पनि यी पर्व मेरो जीवन र <strong>मनोविज्ञानमा</strong> सदैव रहिरहेका छन्।</p>
        <p>(ख) नेपालको लामो इतिहास र सभ्यताले निर्माण गरेका यी <strong>साझा</strong> संस्कृति मेरै संस्कृति थिए?</p>
        <p>(ग) मनुष्य जीवनको सार्थकता भन्नु नै <strong>चेतना</strong> हो।</p>
        <p>(घ) मैले यस यात्रामा सामेल भएर <strong>आवाज</strong> दिएँ।</p>
        <p>(ङ) मनुष्यको मनुष्यत्व र मानवको <strong>मानवता</strong> नै सबैभन्दा ठूलो कुरा हो।</p>
      </div>
      <div>
        <h5>५. ” जीवन एउटा प्रवाहशील ………तरखरमा थिएँ ” निबन्धांश पढी सोधिएका प्रश्नहरुको उत्तर दिनुहोस् ।</h5>
        <h5>(क) जीवनलाई किन यात्रा भनिएको हो ?</h5>
        <p>= नेपालको पूर्वी पहाडी भेगमा जन्मेकी सुधा त्रिपाठीद्वारा लेखिएको आत्मपरक निबन्ध ‘संस्कृतिको नयाँ यात्रा’ मा उनले जीवनलाई यात्रा भनेकी छन्। जीवनलाई यात्रा भनिएको कारण के हो भने यो निरन्तर गतिमा रहने प्रक्रिया हो| कहिले सुखका तर्खर, कहिले दुःखका भोगाइहरूले भरिएको। जसरी नदी अविरल बगिरहन्छ, त्यसरी नै जीवन पनि निरन्तर चलिरहन्छ। त्यसैले जीवनलाई यात्रा भनिएको हो।</p>

        <h5>(ख) अनुच्छेदका आधारमा म पात्रलाई चिनाउनुहोस् ।</h5>
        <p>= ‘म’ पात्र पहाडको दुर्गम गाउँमा जन्मेकी एक शिक्षित महिला हुन्। शिक्षाका लागि उनी काठमाडौँ आइपुग्छिन् र आफ्नो जीवनलाई यात्रा र फूलबारीका विरुवासँग तुलना गर्छिन्। उनी आफूलाई विस्तारै फुल्न लागेको फूलझैँ अनुभूत गर्छिन्, जो जीवनका तर्खरमा छे।</p>

        <h5>(ग) नेपाली जीवनलाई किन विविधताको सुन्दर साङ्लो भनिएको हो ?</h5>
        <p>= नेपालमा विभिन्न जातजाति, भाषा, धर्म, संस्कृति र भौगोलिक परिवेशमा एकतामा बाँधिएर बसोबास गर्ने नेपाली समाज विविधतायुक्त छ। यस विविधताभित्र एकताको सौन्दर्य पाइन्छ। यही कारण नेपाली जीवनलाई विविधताको सुन्दर साङ्लो भनिएको हो।</p>

        <h5>(घ) अनुच्छेदमा नेपालमा रहेका कुन कुन संस्कृति उल्लेखित छन् ?</h5>
        <p>= अनुच्छेदमा काठमाडौंको नेवार, मुस्ताङको थकाली, पूर्वको किराँत, उत्तरको शेर्पा, तराईको मधेसी, पश्चिमको मगर र थारु, साथै दार्चुला, कर्णाली हुँदै कञ्चनजङ्घासम्मका विभिन्न सांस्कृतिक समूहहरूको चर्चा गरिएको छ।</p>
      </div>
      <hr/>
      <div>
        <h5>६. दिइएको निबन्धांश पढी सोधिएका प्रश्नहरुको उत्तर लेख्नुहोस् ।</h5>
        <h5>(अ) जीवनमा आलोचनात्मक हुन के गर्नुपर्छ ?</h5>
        <p>= जीवनमा आलोचनात्मक बन्न प्रश्न गर्न सक्नुपर्छ। प्रश्नले तथ्य उजागर गर्छ र तथ्यबाट नै सत्यको बोध हुन्छ। प्रश्न गर्ने बानीले मानिसलाई विवेकी, तार्किक र बौद्धिक बनाउँछ। त्यसैले आलोचनात्मक सोच विकास गर्न निरन्तर प्रश्न गर्ने अभ्यास गर्नुपर्छ।</p>
        <h5>(आ) निबन्धांशमा कस्तो संस्कृतिको परिकल्पना गरिएको छ ?</h5>
        <p>= निबन्धांशमा जात, धर्म, वर्ण, रंग, वर्ग वा लिङ्गको आधारमा विभेद नगर्ने; सबैको मूल्य, मान्यता र अस्तित्वलाई सम्मान गर्ने; न्याय, समानता, शान्ति र सहिष्णुतामा आधारित साझा संस्कृतिको परिकल्पना गरिएको छ।</p>
      </div>
      <hr/>
      <div>
        <h5>७. दिइएको निबन्धांश पढी सोधिएका प्रश्नहरुको उत्तर दिनुहोस् ।</h5>
        <h5>(अ) संस्कृति भनेको के हो ?</h5>
        <p>= संस्कृति भनेको हाम्रो जीवनशैली, चिन्तन, व्यवहार, मूल्य र मान्यताको समुच्चय हो। यो हाम्रो परिचय, पहिचान र आत्मअनुभूतिको आधार हो, जसले हामी नेपाली हौँ भन्ने मौलिक पहिचान दिन्छ।</p>
        <h5>(आ) संविधानले सुनिश्चित गरेका सांस्कृतिक विषयहरु के के हुन् ?</h5>
        <p>= संविधानले हरेक जातजाति, समुदाय र क्षेत्रले आफ्ना भाषा, लिपि, संस्कृति, सांस्कृतिक सभ्यता र सम्पदाको संरक्षण तथा प्रवर्द्धन गर्ने अधिकार सुनिश्चित गरेको छ। साथै, संस्कृति र सम्पदाको नाममा वर्ण, रङ, जात, धर्म, वर्ग, लिङ्ग वा सम्प्रदायका आधारमा हुने विभेदको अन्त्य हुनुपर्ने कुरा पनि संविधानले व्यवस्था गरेको सांस्कृतिक विषयमध्ये पर्दछ।</p>
      </div>
      <hr/>
      <div>
        <h5>८. उत्तर लेख्नुहोस्:</h5>
        <h5>(क) नेपालमा के कस्ता सांस्कृतिक विविधता छन् ?</h5>
        <p>= नेपाल बहुजातीय, बहुभाषिक, बहुधार्मिक तथा बहुसांस्कृतिक राष्ट्र हो। यहाँ काठमाडौंको नेवार संस्कृति, मुस्ताङको थकाली, पूर्वको किरात, उत्तरको शेर्पा, तराई मधेसको मधेसी, पश्चिमको मगर र थारु संस्कृति लगायतका थुप्रै जातजातिका सांस्कृतिक विविधता पाइन्छन्। यी विविध संस्कृतिहरू मिलेर नेपाललाई सांस्कृतिक विविधताको सुन्दर फूलबारी बनाएका छन्।</p>

        <h5>(ख) श्रम र संस्कृति कसरी अन्तरसम्बधित हुन्छन् ?</h5>
        <p>= श्रमिक वर्गले श्रमबाट जीवन यापन गर्छ र उनीहरूको जीवनशैली, आस्था, परम्परा र संस्कार श्रमसँग गाँसिएका हुन्छन्। उनीहरूको संस्कृति श्रममै आधारित हुन्छ| त्यहीँ फुल्छ, फक्रिन्छ र विकास हुन्छ। लोकजीवन, लोकसंस्कृति, लोककथा जस्ता कुराहरू श्रमिक वर्गकै संस्कृति हुन्। त्यसैले श्रम र संस्कृति परस्पर अन्तरसम्बन्धित हुन्छन्।</p>
        <h5>(ग) न्यायपूर्ण संस्कृतिको निर्माण कसरी गर्न सकिन्छ , निबन्धका आधारमा लेख्नुहोस् ।</h5>
        <p>= न्यायपूर्ण संस्कृतिको निर्माण गर्न वर्ग, जाति, धर्म, लिङ्ग आदि कुनै पनि आधारमा विभेद नगरी सबैलाई समान अधिकार र अवसर प्रदान गर्नुपर्छ। संविधानले महिलालगायत सबै नागरिकलाई समान अधिकार सुनिश्चित गरेको छ। ती अधिकारलाई व्यवहारमा कार्यान्वयन गर्दै समावेशी, समानतामूलक र सम्मानजनक समाज निर्माण गर्न सकेमा न्यायपूर्ण संस्कृति स्थापना गर्न सकिन्छ।</p>
      </div>
      <hr/>
      <div>
        <h5>९. व्याख्या गर्नुहोस् :</h5>
        <h5>(क) नेपालको लामो इतिहास र सभ्यताको निर्माण गरेका यी साझा संस्कृति मेरै संस्कृति थिए, मेरो देशका सम्पत्ति थिए र मेरा ती सबै मित्रहरु एकै फुलबारीका साझा फुलहरु थिए ।</h5>
        <p>= ‘संस्कृतिको नयाँ यात्रा’ कक्षा ११ को नेपाली पाठ्यक्रममा समावेश एक आत्मपरक निबन्ध हो, जसकी लेखिका सुधा त्रिपाठी हुन्। उनले आफूलाई 'म' पात्रको रूपमा प्रस्तुत गर्दै जीवनलाई गतिशील यात्राको रूपमा चित्रण गरेकी छन्। निबन्ध नेपाली समाजमा विद्यमान सांस्कृतिक विविधता, समानता र साझा अस्तित्वको भावनालाई उजागर गर्ने उद्देश्यले लेखिएको छ।</p>
        <p>निबन्धमा लेखकाले नेपालको पूर्वदेखि पश्चिमसम्म फैलिएको विविध जातजाति, भाषा, धर्म र संस्कृतिहरूलाई एउटा साझा फुलबारीका सप्तरङ्गी फूलहरूजस्तो देखेकी छन्। काठमाडौंको नेवार, मुस्ताङको थकाली, पूर्वको किरात, उत्तरको शेर्पा, तराईको मधेसी, पश्चिमको मगर र थारुजस्ता संस्कृतिहरूले नेपाललाई विविधतायुक्त बनाएको छ। यस्ता सबै संस्कृतिहरूलाई उनले आफ्नो संस्कृति मानेकी छन्। यसै विचारलाई प्रस्तुत वाक्यांशले प्रतिबिम्बित गर्छ, "यी साझा संस्कृति मेरै संस्कृति थिए"। उनले संस्कृतिको नाममा हुने विभेदको अन्त्य हुनुपर्ने कुरालाई पनि जोड दिएकी छन्।</p>
        <p>अन्ततः, सुधा त्रिपाठीले ‘म’ पात्रको माध्यमबाट जीवनलाई गतिशील यात्रा र नेपाललाई सांस्कृतिक विविधताको एकतामा बाँधिएको फुलबारीको रूपमा चित्रण गरेकी छन्। उनले कुनै जात, धर्म, वर्ण, वर्ग वा लिङ्गका आधारमा विभेद नगरिने, सबैलाई सम्मान दिने साझा संस्कृतिको कल्पना गरेकी छन्। निबन्ध सरल भाषाशैलीमा लेखिएको भए पनि यसले गहिरो राष्ट्रिय एकता र समानताको सन्देश दिन सफल भएको छ।</p>
      </div>
      <hr/>
      <div>
        <h5>(ख) संस्कृतिका नाममा…………………………………..भेद विकृति हुन् ।</h5>
        <p>= प्रस्तुत गद्यांश कक्षा ११ को नेपाली पाठ्यपुस्तकमा समावेश ‘संस्कृतिको नयाँ यात्रा’ नामक निबन्धबाट साभार गरिएको हो। यस निबन्धकी लेखिका सुधा त्रिपाठी हुन्, जो विशेष रूपमा सांस्कृतिक विषयमा लेख्ने प्रभावशाली स्रष्टा हुन्। उनले निबन्धमा आफूलाई ‘म’ पात्रको रूपमा प्रस्तुत गर्दै जीवनलाई सांस्कृतिक यात्राको रूपमा चित्रण गरेकी छन्।</p>
        <p>उक्त वाक्यांशले नेपालमा संस्कृतिको नाममा भइरहेका विभेद र विकृतिप्रति ध्यानाकर्षण गराएको छ। नेपाल जति सांस्कृतिक रूपमा समृद्ध छ, त्यति नै कतिपय क्षेत्रमा संस्कृतिका नाममा सामाजिक विभेद पनि पाइन्छ। विशेष गरी दुर्गम गाउँघरमा जात, वर्ण, लिङ्ग, वर्ग आदिका आधारमा गरिने व्यवहारले सामाजिक सद्भावमा अवरोध पुर्‍याइरहेको छ। परम्परागत सोच, रूढीवादी परिपाटी र अनुचित अभ्यासका कारण संस्कृतिमा विकृति देखिएको छ। निबन्धमा ‘म’ पात्रले यस कुरालाई अनुभव गरेर यस्ता विभेदहरूको अन्त्य हुनु आवश्यक छ भन्ने सन्देश प्रवाह गरेकी छन्।</p>
        <p>निबन्धमा जीवनलाई एक सांस्कृतिक यात्रा मानेर सुधा त्रिपाठीले समाजमा व्याप्त विकृतिपूर्ण संस्कृतिको अन्त्य गर्नुपर्ने सन्देश दिन खोजेकी छन्। सरल भाषा र आत्मपरक शैलीमा लेखिएको यस निबन्धले पाठकलाई सामाजिक चेतना र एकताको भावना दिलाउँछ। उनले देखाएझैँ, साझा संस्कृतिको सम्मान गर्दै भेदभावरहित समाज निर्माण गर्नु नै नेपाली जीवनको साँचो प्रगति हो।</p>
      </div>
      <hr/>
      <div>
        <h5>१०. समीक्षात्मक उत्तर लेख्नुहोस्:</h5>
        <h5>(क) नेपालमा विद्यमान संस्कृतिका सबल र दुर्बल पक्षको चर्चा गर्नुहोस् ।</h5>
        <p>= नेपाल बहुजातीय, बहुभाषिक, बहुधार्मिक, र बहुसांस्कृतिक मुलुक हो। यहाँ विभिन्न जातजाति, भाषा, धर्म, संस्कार र सांस्कृतिक अभ्यासहरू विद्यमान छन्, जसले नेपालको पहिचानलाई समृद्ध बनाएका छन्। सुधा त्रिपाठीको ‘संस्कृतिको नयाँ यात्रा’ निबन्धले नेपाली सांस्कृतिक विविधता र त्यसका सबल तथा दुर्बल पक्षहरूलाई मननशील तरिकाले प्रस्तुत गरेको छ।</p>
        <p>नेपालको सांस्कृतिक विविधता नै यसको सबैभन्दा ठूलो शक्ति हो। यस देशका मानिसहरूले आफ्नो फरक–फरक जातीय र सांस्कृतिक पृष्ठभूमि भएतापनि सहिष्णुता र सम्मानको वातावरणमा सहअस्तित्व गर्दै आएका छन्। काठमाडौंको नेवार संस्कृति, मुस्ताङको थकाली, पूर्वी नेपालको किरात, उत्तरको शेर्पा, तराई मधेसका मधेसी, पश्चिमी नेपालको मगर र थारु लगायतका समुदायका सांस्कृतिक रीतिथितिहरूले नेपाललाई सांस्कृतिक फूलबारीको रूपमा चित्रित गर्छन्। यी विविध संस्कृतिहरूले नेपाली समाजमा गहिरो ऐक्यबद्धता र राष्ट्रिय एकता ल्याउने काम गरेका छन्। संस्कृतिको यो समृद्धि, विविधताको स्वीकृति र पारस्परिक सहिष्णुताले नेपाललाई विश्वमा सांस्कृतिक दृष्टिले एक अद्वितीय पहिचान दिएको छ। यो एकता नै नेपाली जनताको साझा गौरव र पहिचान हो।
</p><p>
यसका साथै, सांस्कृतिक पर्व–परम्पराहरू, भाषा, संगीत, नृत्य, लिङ्ग तथा जातीय पहिचानलाई संरक्षण र प्रवर्द्धन गर्ने कार्यहरू पनि सबल पक्षमा पर्छन्। सरकारले संविधानले सबै समुदायलाई आफ्नै भाषा, लिपि, संस्कृति, र परम्पराको संरक्षण र प्रवर्द्धन गर्ने अधिकार दिएको छ, जसले संस्कृतिको दीर्घकालीन अस्तित्व सुनिश्चित गरेको छ।</p>
<p>तर, यस्ता सबल पक्षहरूको बावजुद पनि नेपालमा संस्कृतिको नाममा केही दुर्बल पक्षहरू पनि देखिन्छन्। जातीय विभेद, सामाजिक भेदभाव, लिङ्गीय असमानता, धार्मिक भेद, र वर्गीय भेदका कारण कतिपय समुदायहरू अझै पनि सामाजिक रूपमा पिछडिएका छन्। यो विकृत व्यवहार संस्कृतिको नाममा परम्परागत रूढिवाद, अन्धविश्वास र विभाजनकारी मानसिकताबाट उत्पन्न भएको हो।
</p><p>
दुर्गम क्षेत्रहरूमा अझै जातीय र वर्गीय भेद व्यापक छन्। ती स्थानहरूमा गरिबी, अशिक्षा र सामाजिक चेतनाको कमीका कारण भेदभाव र बहिष्कार प्रचलित छ। यसले सामाजिक सद्भावमा अवरोध पु¥याउँछ र समग्र समाजलाई कमजोर बनाउँछ। महिलाहरू र अन्य अल्पसंख्यक वर्गहरू पनि कतिपय अवस्थामा आफ्नो अधिकारबाट वञ्चित हुनुपरेको पाइन्छ। यसका साथै सांस्कृतिक नाममा गरिने व्यवहारले सामाजिक एकतालाई खतरामा पार्ने जोखिम राख्छ।
</p><p>
परम्परागत संस्कृतिले आधुनिक समाजको मागअनुसार परिवर्तन नपाएको, रूढिवादी विचारहरू अझै कायम रहेको र नयाँ सोच र आधुनिकताको अवहेलना गरेको अवस्थालाई पनि संस्कृतिको दुर्बल पक्ष मान्न सकिन्छ। यसले सांस्कृतिक प्रगतिमा बाधा पुर्याउँछ।

</p>

      </div>
      <hr/>
      <div>
        <h5>(ख) `सांस्कृतिक रुपमा न्यायपूर्ण समाजले मात्र समतामूलक समाजको निर्माण गर्न सक्छ´ विवेचना गर्नुहोस् ।</h5>
        <p>सुधा त्रिपाठीले आफ्नो निबन्धमा सांस्कृतिक विविधता र त्यसमा व्याप्त विभेद तथा विकृतिहरूको चर्चा गर्दै सांस्कृतिक न्यायको महत्त्वलाई उजागर गरेकी छन्। हाम्रो देश नेपाल विविध भूगोल, जाति, भाषा, धर्म, लिङ्ग र वर्गको मेलमिलाप भएको मुलुक हो, जहाँ विविधता सँगसँगै विभेद र अन्याय पनि व्याप्त छ। सांस्कृतिक रूपमा न्यायपूर्ण समाज निर्माण गर्नु समतामूलक र समृद्ध समाजको आधार हो।</p>
        <p>संस्कृति कुनै पनि राष्ट्र वा समाजको आधारभूत धरोहर हो। प्रत्येक व्यक्तिको आफ्नै सांस्कृतिक पहिचान र अनुभूति हुन्छ। तर जब सांस्कृतिक पहुँच र अवसरमा विभेद आउँछ जस्तो कि महिला, गरिब, अल्पसंख्यक, वा ग्रामीण क्षेत्रका मानिसहरूलाई सामाजिक र सांस्कृतिक पहुँचबाट वञ्चित गरिनु, त्यसले सामाजिक समग्र विकासमा बाधा पुर्‍याउँछ।
</p><p>
सांस्कृतिक भेदभाव जस्तै जाति, धर्म, लिङ्ग, वर्ग वा क्षेत्रीय आधारमा हुने विभाजनहरूले सामाजिक एकता र मेलमिलापलाई कमजोर बनाउँछन्। जबसम्म यी विकृतिहरूलाई हटाइँदैन, तबसम्म समतामूलक समाजको कल्पना अधुरो नै रहन्छ। संविधानले पनि यस्ता विभेदलाई गैरकानुनी र अस्वीकार्य भनेको छ। कानून र व्यवहारबीचको अन्तरलाई हटाएर सबैलाई समान सांस्कृतिक अधिकार सुनिश्चित गर्न आवश्यक छ।
</p><p>
सांस्कृतिक न्याय भनेको सबैले आफ्नो संस्कृतिलाई सम्मानका साथ अंगिकार गर्ने, समान अवसर पाउने र भेदभावमुक्त वातावरणमा जीवनयापन गर्ने अधिकार पाउनु हो। यस्तो न्यायपूर्ण समाजमा मात्र सबै वर्ग र समुदायबीच समानता स्थापित हुन्छ र समृद्धि सम्भव हुन्छ।</p>
<p>सांस्कृतिक रूपमा न्यायपूर्ण समाज निर्माण गर्न सबैले समान अधिकार पाउनुपर्छ, सबैका संस्कृतिहरूको सम्मान हुनुपर्छ र विभेद तथा भेदभावको अन्त्य हुनुपर्छ। यस्तो समाजमा मात्र सबै नागरिकले बराबरी अनुभूति गर्नेछन् र राष्ट्रिय विकासमा समान रूपमा योगदान दिन सक्नेछन्। त्यसैले सांस्कृतिक न्यायको स्थापना नै समतामूलक समाजको आधारशिला हो।</p>
      </div>
      <hr/>
      <div>
        <h5>११. दिइएको अनुच्छेद पढी सोधिएका प्रश्नहरुको उत्तर दिनुहोस् ।</h5>
        <h5>(क) संस्कृतिभित्र के के लुकेका हुन्छन् ?</h5>
        <p>= संस्कृतिभित्र कुनै पनि जातजातिका लुगा, भोजन, भाषा, दर्शन, मान्यता, विश्वास, र जीवनशैली लुकेका हुन्छन्।</p>
        <h5>(ख) बहुजातीय मुलुकका के कस्ता विशेषता हुन्छन् ?</h5>
        <p>= बहुजातीय मुलुकमा सांस्कृतिक विविधता, सांस्कृतिक सम्पन्नता, जातीय पृथकता, जातीय सद्भाव, राष्ट्रिय एकता, धार्मिक र सांस्कृतिक मेलजोल जस्ता विशेषताहरू हुन्छन्।</p>
        <h5>(ग) `संस्कृति मधुरस हो, सभ्यता धार हो´ भन्नाको तात्पर्य के हो ?</h5>
        <p>= जसरी बिना धार भएको विना मधुरस संचित गर्न सकिँदैन, ठीक त्यसरी सभ्यता नहुँदा संस्कृति फुल्न सक्दैन। नेपालीहरूको साझा सभ्यता र संस्कृतिले नेपाललाई मधुरसले भरिएको मौरीको घारजस्तै बनाएको छ भन्ने अर्थ यस वाक्यांशको हो।</p>
        <h5>(घ) `पृथक्ता´ र `अभ्यागत´को अर्थ लेख्नुहोस् ।</h5>
        <p>पृथकता: भिन्नता, छुट्टैपन</p>
        <p>अभ्यागत: पाहुना, अतिथि</p>
      </div>
      <hr/>
      <div>
        <h3>व्याकरण अभ्यास</h3>
        <h3>पदवर्ग: नाम</h3>
        <h5>१. दिइएको अनुच्छेद पढी नाम वर्गका शब्दको पहिचान गर्नुहोस् ।</h5>
        <p>हुल, भिक्षु , स्तूप, परिक्रमा, सहर, भीमसेन, स्तम्भ, मन्जु, स्वयम्भू, प्राङ्गण, वुवा, खुशी, व्यक्त, नारायणहिटी, दरबार, सिंहदरबार, हनुमानढोका, एयरपोर्ट, कीर्तिपुर,महिमा, काठमाडौं, दृश्य, हात, प्रसाद, झोला, बाँदर ।</p>
        
      </div>
      <hr/>
      <div>
        <h5>२. दिइएका शब्दहरुबाट एउटै उपवर्गमा पर्ने नामहरुको सुची बनाउनु होस् ।</h5>
        <h5>(क) व्यक्तिवाचक नाम</h5>
        <p>गोपाल, काठमाडौं, कर्नाली, रामायण, मुनामदन, तिहार, होली, तिज, धरमपुर, दसैँ</p>
        <h5>(ख) जतिवाचक नाम</h5>
        <p>फूल, गाई, माछो, किताब, घर, विद्यालय, जुत्ता, औंठी, टोपी, साइकल, कार</p>
        <h5>(ग) समूहवाचक नाम</h5>
        <p>वथान, लहर, चाङ, खात, फौज, झुप्पो</p>
        <h5>(घ) द्रव्यवाचक नाम</h5>
        <p>रगत, कुहिरो, ढुङ्गा, माटो, सुन, चाँदी, चामल, पानी, शोभिता, तेल</p>
        <h5>(ङ) भाववाचक नाम</h5>
        <p>रिस, बसाइ, चोरी, युद्ध, मुर्ख्याइँ, प्रेम, घृणा, मानवता, शिक्षा, पढाई, जवानी, गरिबी, बाल्यावस्था</p>
      </div>
      <hr/>
      <div>
        <h5>३. दिइएको अनुच्छेदबाट बिसओटा नाम शब्द टिप्नुहोस् ।</h5>
        <p>नेपाल, पर्व, नारी, रुप, गौरा, महिला, व्रत, भगवान्, शिव, पार्वती, पुजा, सुख, समृद्धि, कामना, नदी, घर, पोखरी, चना, गहुँ, मकै </p>
      </div>
      <hr/>
      <div>
        <h5>४. पाठको पहिलो अनुच्छेदमा रहेका नाम शब्दहरु टिप्नुहोस् ।</h5>
        <p>वाल्यकाल, दसैँ, स्मृति, हृदय, नेपाल, पहाड, गाउँ, संस्कृत, महिना, बुबा, आमा, झरना, कोसी, नदी, लेखनाथ, बाढी, झरी, पहिरो, हिलो, धर्ती, पुर्खा, लुगा, पिङ, खाना, केरा, कुराउनी, मासु, चिउरा, परिकार, दक्षिणा, बालिका, तिहार, खुशी, जीवन </p>
      </div>
      <hr/>
      <div>
        <h3>पदवर्ग: सर्वनाम</h3>
        <h5>१. दिइएको अनुच्छेदमा नामको सट्टामा उपयुक्त सर्वनाम पद प्रयोग गरि पुनर्लेखन गर्नुहोस् ।</h5>
        <p>(क) आमाबुबाले छोराछोरीलाई पढ्नका लागि धनगढी पठाए । उनीहरु त्यहाँ बसी धेरै पढे । छोरी पढीसकेपछी गाउँ फर्की । उसले गाउँमा एउटा विद्यालय खोली । केही वर्षपछि छोरो पनि गाउँमै फर्क्यो । उसले पनि त्यस विद्यालयमा पढाउन थाल्यो । आमाबुबा खुशी हुनुभयो ।</p>
        <p>(क) आमाबुबाले छोराछोरीलाई पढ्नका लागि धनगढी पठाए । उनीहरु त्यहाँ बसी धेरै पढे । छोरी पढीसकेपछी गाउँ फर्की । उसले गाउँमा एउटा विद्यालय खोली । केही वर्षपछि छोरो पनि गाउँमै फर्क्यो । उसले पनि त्यस विद्यालयमा पढाउन थाल्यो । आमाबुबा खुशी हुनुभयो ।</p>
      </div>
      <hr/>
      <div>
        <h5>२. दिइएका सर्वनामलाई मिल्दाजुल्दा उपवर्गमा सूचीकृत गर्नुहोस् ।</h5>
        <h5>(क) पुरुषवाचक सर्वनाम</h5>
        <p><strong>(अ) प्रथम पुरुषवाचक : </strong>म, हामी</p>
        <p><strong>(आ) द्वितीय पुरुषवाचक :</strong>तँ ,तिमी, तपाई ,तपाईंहरु</p>
        <p><strong>(इ) तृतीय पुरुषवाचक : </strong>ऊ, त्यो, उनी, उनीहरु, उहाँ, उहाँहरु</p>
        <h5>(ख) दर्शकवाचक सर्वनाम</h5>
        <p>यो, यी, यिनीहरु, त्यो, ती, तिनीहरु</p>
        <h5>(ग) सम्बन्धवाचक सर्वनाम</h5>
        <p>जो, जे, जुन, जेसुकै, जोसुकै, जुनसुकै</p>
        <h5>(घ) प्रश्नवाचक सर्वनाम</h5>
        <p>को, के, कुन, केही, कोही, कुनै</p>
        <h5>(ङ) निजवाचक सर्वनाम</h5>
        <p>आफू, आफैं, स्वयम्, निज, अरु</p>
      </div>
      <hr/>
       <div>
        <h5>३. दिइएको गद्यांश पढी दशवटा सर्वनाम टिप्नुहोस् ।</h5>
        <p>म, हामी, तिमी, उनीहरु, तपाईं, को को, ऊ, जोसुकै, तँ, यस, आफै</p>
       </div>
       <div>
        <h5>४. दिइएका सर्वनामलाई अर्थ खुल्ने गरी वाक्यमा प्रयोग गर्नुहोस् ।</h5>
        <strong>त्यो</strong>
        <p>त्यो घर धेरै पुरानो भए पनि अझै मजबुत छ।</p>
        <strong>तिनीहरु</strong>
        <p>तिनीहरू हिजो पार्कमा फुटबल खेलिरहेका थिए।</p>
        <strong>यी</strong>
        <p>यी फूलहरू हिजोमात्रै बगैँचाबाट टिपिएका हुन्।</p>
         <strong>स्वयम्</strong>
         <p>उहाँले त्यो काम स्वयम् गरे।</p>
        <strong>जे</strong>
        <p>जे हुन्छ, म तिमीलाई सघाउन तयार छु।</p>
        <strong>को</strong>
        <p>त्यहाँ को बसिरहेको छ?</p>
        <strong>के</strong>
        <p>तिमीले मलाई के भन्यौ?</p>
        <strong>आफू</strong>
        <p>उसले आफू गल्तीमा परेको स्वीकार गर्‍यो।</p>
        <strong>उहाँ</strong>
        <p>उहाँ आज विद्यालय आउनुभएन।</p>
        <strong>कोही</strong>
        <p>कोही मानिस ढोका ढकढक्याउँदै थियो।</p>
        <strong>प्रत्येक</strong>
        <p>प्रत्येक विद्यार्थीले समयमै गृहकार्य बुझाउनु पर्छ।</p>
        <strong>अरु</strong>
        <p>अरू साथीहरू पनि कार्यक्रममा सहभागी थिए।</p>
        <strong>सबै</strong>
        <p>सबै बालबालिकालाई मिठाई बाँडियो।</p>
        <strong>केही</strong>
        <p>केही पुस्तकहरू अझै पुस्तकालयमा फिर्ता गर्न बाँकी छन्।</p>
        <strong>हजुर</strong>
        <p>हजुरको सुझाव मेरो लागि अमूल्य छ।</p>
       </div>
       <hr/>
       <div>
        <h3>पदवर्ग - विशेषण</h3>
        <h5>१. दिइएको गद्यांशबाट विशेषण शब्द पहिचान गरी लेख्नुहोस् ।</h5>
        <p>एक, दुइटा, त्यस, एउटा, ठुलो, चलाख, कमजोर, धुर्त, मेरा, यो, धमिलो, प्रिय, सफा, सानो ।</p>
       </div>
       <hr/>
       <div>
        <h5>२. दिइएका पदावलीबाट विशेषण शब्द छानी तिनलाई उपवर्गमा वर्गीकरण गर्नुहोस् ।</h5>
        <strong>(क) गुणबोधक विशेषण</strong>
        <p>सेतो, बलियो, गतिलो, बुझक्कड, चड्दो, शीतल, सांस्कृतिक, नैतिक, मलिलो</p>
        <strong>(ख) सङ्ख्याबोधक विशेषण</strong>
        <p>लाखौं, पाँच, सयौं, सप्त</p>
        <strong>(ग) परिमाणबोधक विशेषण</strong>
        <p>प्रशस्त, अलिकति, थोरै, सबै</p>
        <strong>(घ) सार्वनामिक विशेषण</strong>
        <p>यो, त्यो, यी, ती</p>
        <strong>(ङ) भेदक विशेषण</strong>
        <p>उसको, मेरो, तिम्रो</p>
       </div>
       <hr/>
       <div>
        <h5>३. दिइएको अनुच्छेदबाट दशओटा विशेषण शब्द पहिचान गरि टिपोट गर्नुहोस् ।</h5>
        <p>मेरो, सेता, हरियो, उर्वरशील, विविध, अनेक, सयौं ,मेहनती, यस, वीर, स्वच्छ, प्राकृतिक, नेपालको ।</p>
       </div>
       <hr/>
       <div>
        <h5>४. ` संस्कृतको नयाँ यात्रा´ निबन्धबाट पाँचवटा विशेषण शब्दहरु टिप्नुहोस् ।</h5>
        <p>मेरो, एक,निलो, मीठो, यी, दुर्गम, गतिशील, साझा, सबै, वास्तविक, हाम्रो, नयाँ ।</p>
       </div>
       <hr/>
       <div>
        <h3>पदवर्ग - क्रिया</h3>
        <h5>१. दिइएको गद्यांशबाट क्रियापद पहिचान गरी लेख्नुहोस् ।</h5>
        <p>झुके, वने, सकेनन्, सजिए, बनेनन् , सकेनौँ, पोलिए, बद्लिए, बहकिए, मिसिए, लरबरियो, रह्यो </p>
       </div>
       <hr/>
       <div>
        <h5>२. दिइएका क्रियापद प्रयोग गरी आफूलाई मनपर्ने विषयमा छोटो अनुच्छेद लेख्नुहोस् ।</h5>
        <p>मेरो भाइले सरकारी जागिर खान्छ । उसले सरकारी स्कुलमा नै पढ्यो । अहिले भाइ विद्यालयमा पढाउन गएको छ । उसके असल शिक्षक बनी नाम कमाओस् भन्ने मेरो चाहाना छ । भाइ विद्यालयबाट कतिखेर आउला भनी म उसैको पर्खाइमा बसेको थियो । भाइ विद्यार्थीसँगै बाटोमा हिड्दै थियो भनेर श्यामले भन्न नपाउँदै आँगनीमा टुप्लुक्क आइपुगेको भाइले श्याम झुट बोल्छन् भनी रिसाएझै गर्दा श्याम त डराएर जुरुक्कै उठेछ ।</p>
       </div>
       <hr/>
       <div>
        <h5>३.दिइएका क्रियापदलाई मिल्दो उपवर्गमा वर्गीकरण गर्नुहोस् ।</h5>
        <h5>१. अर्थप्रधानताका आधारमा</h5>
        <strong>(क) मुख्य क्रिया</strong>
        <p>सुन्छ, पढ्छ,हाँस्छ, भयो, रुदैँ, हुन्छ, ल्याउँछ, बनाउँछ, आइ, गएको, हुनु, उम्रँदै, वाङ्गिन्छ, भुतभुताउनु, छापेको, फरफरायो, कलकलाउँछ, लेख्छ, दियो, पढ्ने, भएको, भिजाउँदै, गर्दछौं, सुनिन्छ ।</p>
        <strong>(ख) सहायक क्रिया</strong>
        <p>छ, हाल्छ, सक्यो, पगे, हो, थियो, छन् , सकेछ ।</p>
       </div>
       <hr/>
       <div>
        <h5>२. बनोटका आधारमा</h5>
        <strong>(क) सरल क्रिया</strong>
        <p>सुन्छ, पढ्यो, ल्याउँछ, सक्यो, बनाउँछ, भयो, खोज्यौँ, वाङ्गिन्छ, फरफरायो, कलकलाउँछ, लेख्छ,दियो, गर्दछौ, सुनिन्छ ।</p>
        <strong>(ख) जटिल क्रिया</strong>
        <p>भनिहाल्छ, रुदै छ, आइसक्यो, आइपुगे, गएको हुने छ, उम्रँदै छ, भुतभुताएको छ, छापेको थियो, पढ्ने छ, भएको छ, भिजाउँदै छ, लेखिसकेछ ।</p>

       </div>
       <hr/>
       <div>
        <h5>३. कर्मका आधारमा</h5>
        <strong>(क) सकर्मक क्रिया</strong>
        <p>सुन्छ, पढ्यो, ल्याउँछ, बनाउँछ, खोज्यौ, लेख्छ, दियो, पढ्ने छ, भिजाउँदै छ, गर्दछौ ।</p>
        <strong>(ख) अकर्मक क्रिया</strong>
        <p>हाँस्छे, दगुर्छन्, रुँदै छ, आइसक्यो, छ, हो, उम्रँदै छ, फरफरायो, कलकलाउँछ, भएको छ, सुनिन्छ ।</p>
       </div>
       <hr/>
       <div>
        <h5>४. दिइएको अनुच्छेदबाट बाह्रओटा क्रिया टिप्नुहोस् ।</h5>
        <p>पर्दै छ, भएको छ, ल्यायो, हरायो, वगायो, पुर्यो, आएछ, सुन्छु, हेर्छु, छुन्छ, रुवाउँछ, पर्छन्, बन्दछ ।</p>
       </div>
       <hr/>
       <div>
        <h5>५. `संस्कृतिको नयाँ यात्रा´ निबन्धको दोस्रो अनुच्छेदबाट पन्ध्रओटा क्रियापद टिप्नुहोस् ।</h5>
        <p>हो, रहेछौ, रहेछ, पुगेँ, भयो, थालेँ, पाएँ, मनाउँथ्यौ, मनाउँथे, गाउँथे, गर्थे, बताउँथे, भएँ, बुझेँ, गरेँ, थिए ।</p>
       </div>
    </div>

  )
}

export default Sanskritikonayayatra
